import React, { useState, useEffect } from 'react';
import { recallService } from '../../services/recallService';
import { vehicleService } from '../../services/vehicleService';

const RecallData = () => {
  const [bases, setBases] = useState([]);
  const [masterModels, setMasterModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const initialForm = { id: null, recallType: '자진리콜', title: '', modelName: '', startDate: '', endDate: '', reason: '', standardLabor: '', partsRequired: '', memo: '' };
  const [formData, setFormData] = useState(initialForm);

  const refresh = async () => {
    setLoading(true);
    const bData = await recallService.getRecallBase();
    const mData = await vehicleService.getVehicleModels();
    setBases(bData || []);
    setMasterModels(mData || []);
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const onSave = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.modelName) return alert("캠페인 명칭과 대상 모델은 필수입니다.");

    setLoading(true);
    try {
      if (isEditing) {
        await recallService.updateRecallBase(formData.id, formData);
        alert("✅ 리콜 정책이 수정되었습니다.");
      } else {
        await recallService.addRecallBase(formData);
        alert("✅ 리콜 정책이 새롭게 등록되었습니다.");
      }
      setFormData(initialForm);
      setIsEditing(false);
      await refresh();
    } catch (error) {
      alert("❌ 저장 중 오류가 발생했습니다. 다시 시도해 주세요.");
    }
    setLoading(false);
  };

  const handleEdit = (b) => { setFormData(b); setIsEditing(true); window.scrollTo(0, 0); };
  const handleDel = async (id) => { if (window.confirm("정말 삭제할까요?")) { await recallService.deleteRecallBase(id); await refresh(); } };

  // 대표님의 원본 디자인 스타일 유지
  const style = {
    wrapper: { padding: '20px' },
    card: { background: 'white', padding: '35px', borderRadius: '20px', boxShadow: '0 4px 25px rgba(0,0,0,0.05)', marginBottom: '30px' },
    input: { width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box' },
    label: { fontSize: '13px', fontWeight: 'bold', color: '#475569', marginBottom: '8px', display: 'block' },
    btnSubmit: { width: '100%', padding: '15px', background: '#8e0a2d', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }
  };

  return (
    <div style={style.wrapper}>
      <div style={style.card}>
        <h2 style={{ margin: '0 0 25px 0' }}>📢 리콜 캠페인 및 정책 설정 (Cloud)</h2>
        <form onSubmit={onSave}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px', marginBottom: '20px' }}>
            <div><label style={style.label}>리콜 구분</label>
              <select style={style.input} value={formData.recallType} onChange={e => setFormData({...formData, recallType: e.target.value})}>
                <option value="자진리콜">📢 자진리콜</option><option value="국토부리콜">🛑 국토부리콜</option>
              </select>
            </div>
            <div><label style={style.label}>리콜 캠페인 명칭</label><input style={style.input} value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} placeholder="예: 로어암 교체" /></div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '20px' }}>
            <div><label style={style.label}>대상 차량 모델</label>
              <select style={style.input} value={formData.modelName} onChange={e => setFormData({...formData, modelName: e.target.value})}>
                <option value="">-- 모델 선택 --</option>
                {masterModels.map(m => <option key={m.id} value={m.modelName}>{m.modelName}</option>)}
              </select>
            </div>
            <div><label style={style.label}>시행 시작일</label><input type="date" style={style.input} value={formData.startDate} onChange={e => setFormData({...formData, startDate: e.target.value})} /></div>
            <div><label style={style.label}>시행 종료일</label><input type="date" style={style.input} value={formData.endDate} onChange={e => setFormData({...formData, endDate: e.target.value})} /></div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '20px', marginBottom: '20px' }}>
            <div><label style={style.label}>결함 내용 요약</label><input style={style.input} value={formData.reason} onChange={e => setFormData({...formData, reason: e.target.value})} /></div>
            <div><label style={style.label}>표준 공임 (Hour)</label><input type="number" style={style.input} value={formData.standardLabor} onChange={e => setFormData({...formData, standardLabor: e.target.value})} /></div>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <label style={style.label}>필요 부품 및 자재</label>
            <input style={style.input} value={formData.partsRequired} onChange={e => setFormData({...formData, partsRequired: e.target.value})} placeholder="예: 로어암 육안 확인 후 교체" />
          </div>

          <button type="submit" disabled={loading} style={style.btnSubmit}>
            {loading ? "처리 중..." : (isEditing ? "리콜 정책 수정 완료" : "리콜 정책 등록")}
          </button>
        </form>
      </div>

      <div style={style.card}>
        <h4>✅ 리콜 정책 데이터베이스 (Cloud 동기화)</h4>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '2px solid #f1f5f9', color: '#64748b' }}>
              <th style={{ padding: '15px' }}>구분 / 캠페인명</th><th style={{ padding: '15px' }}>대상차량</th><th style={{ padding: '15px' }}>시행 기간</th><th style={{ padding: '15px' }}>관리</th>
            </tr>
          </thead>
          <tbody>
            {bases.map(b => (
              <tr key={b.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                <td style={{ padding: '15px' }}>
                  <span style={{ fontSize: '10px', background: '#8e0a2d', color: 'white', padding: '2px 6px', borderRadius: '4px' }}>{b.recallType}</span><br />
                  <b>{b.title}</b>
                </td>
                <td style={{ padding: '15px' }}>{b.modelName}</td>
                <td style={{ padding: '15px', fontSize: '13px' }}>{b.startDate} ~ {b.endDate}</td>
                <td style={{ padding: '15px' }}>
                  <button onClick={() => handleEdit(b)} style={{ border: 'none', background: 'none', color: '#3b82f6', cursor: 'pointer' }}>수정</button>
                  <button onClick={() => handleDel(b.id)} style={{ border: 'none', background: 'none', color: '#ef4444', marginLeft: '10px', cursor: 'pointer' }}>삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecallData;